import { PartnerReferral } from '@/types/partner'
import { formatCurrency } from './format'
import { formatDate } from './date'

export const exportReferralsToCSV = (referrals: PartnerReferral[], filename: string = 'referrals.csv') => {
  // Define CSV headers
  const headers = [
    'Date',
    'Referral ID',
    'Type',
    'Subtype',
    'Project Name',
    'Tranche Size',
    'Valuation',
    'Status',
    'API Key',
    'Order ID',
    'Order Valuation',
    'Order Offered Amount',
    'Terms'
  ]

  // Convert data to CSV rows
  const rows = referrals.map(referral => [
    formatDate(referral.date),
    referral.referral_id,
    referral.referral_type,
    referral.referral_subtype,
    referral.project_name,
    formatCurrency(referral.tranche_size),
    formatCurrency(referral.valuation),
    referral.status,
    referral.key_name,
    referral.order_id || '',
    referral.order_valuation ? formatCurrency(referral.order_valuation) : '',
    referral.order_offered_amount ? formatCurrency(referral.order_offered_amount) : '',
    referral.terms || ''
  ])

  // Combine headers and rows
  const csvContent = [headers, ...rows]
    .map(row => row.map(cell => `"${cell}"`).join(','))
    .join('\n')

  // Create and download file
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', filename)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}

export const exportReferralsToExcel = (referrals: PartnerReferral[], filename: string = 'referrals.xlsx') => {
  // For Excel export, we would need a library like xlsx
  // For now, we'll use CSV as it can be opened in Excel
  exportReferralsToCSV(referrals, filename.replace('.xlsx', '.csv'))
}
